import { jsx as r } from "react/jsx-runtime";
import { Image as f } from "@sitecore-jss/sitecore-jss-nextjs";
import { M as t } from "./module-link.BIP-6VCP.js";
const m = ({
  linkedImage: e,
  linkClass: a,
  imageClass: i,
  onClick: o
}) => e ? "image" in e && "link" in e ? /* @__PURE__ */ r(t, { field: e, className: a, onClick: o, children: /* @__PURE__ */ r(f, { field: e, className: i, editable: !1, loading: "eager" }) }) : /* @__PURE__ */ r(t, { field: e, className: a, onClick: o, children: /* @__PURE__ */ r(f, { field: e, className: i, editable: !1, loading: "eager" }) }) : null;
export {
  m as L
};
